/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CoordinateSystem from './CoordinateSystem';
import CostSettings from './CostSettings';
import Location from './Location';
import TravelCost from './TravelCost';

/**
 * The CostMatrixRequest model module.
 * @module model/CostMatrixRequest
 * @version 0.0.2
 */
class CostMatrixRequest {
    /**
     * Constructs a new <code>CostMatrixRequest</code>.
     * This schema defines the request body for calculating a cost matrix. It includes the locations and travel costs to use for calculating the cost matrix.
     * @alias module:model/CostMatrixRequest
     * @param locations {Array.<module:model/Location>} The locations to use for calculating the cost matrix.
     * @param costSettings {module:model/CostSettings} 
     */
    constructor(locations, costSettings) { 
        
        CostMatrixRequest.initialize(this, locations, costSettings);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, locations, costSettings) { 
        obj['locations'] = locations;
        obj['costSettings'] = costSettings;
    }

    /**
     * Constructs a <code>CostMatrixRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CostMatrixRequest} obj Optional instance to populate.
     * @return {module:model/CostMatrixRequest} The populated <code>CostMatrixRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CostMatrixRequest();

            if (data.hasOwnProperty('locations')) {
                obj['locations'] = ApiClient.convertToType(data['locations'], [Location]);
            }
            if (data.hasOwnProperty('travelCosts')) {
                obj['travelCosts'] = ApiClient.convertToType(data['travelCosts'], [TravelCost]);
            }
            if (data.hasOwnProperty('costSettings')) {
                obj['costSettings'] = CostSettings.constructFromObject(data['costSettings']);
            }
            if (data.hasOwnProperty('coordinateSystem')) {
                obj['coordinateSystem'] = CoordinateSystem.constructFromObject(data['coordinateSystem']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CostMatrixRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CostMatrixRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CostMatrixRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        if (data['locations']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['locations'])) {
                throw new Error("Expected the field `locations` to be an array in the JSON data but got " + data['locations']);
            }
            // validate the optional field `locations` (array)
            for (const item of data['locations']) {
                Location.validateJSON(item);
            };
        }
        if (data['travelCosts']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['travelCosts'])) {
                throw new Error("Expected the field `travelCosts` to be an array in the JSON data but got " + data['travelCosts']);
            }
            // validate the optional field `travelCosts` (array)
            for (const item of data['travelCosts']) {
                TravelCost.validateJSON(item);
            };
        }
        // validate the optional field `costSettings`
        if (data['costSettings']) { // data not null
          CostSettings.validateJSON(data['costSettings']);
        }

        return true;
    }


}

CostMatrixRequest.RequiredProperties = ["locations", "costSettings"];

/**
 * The locations to use for calculating the cost matrix.
 * @member {Array.<module:model/Location>} locations
 */
CostMatrixRequest.prototype['locations'] = undefined;

/**
 * The travel costs to use for calculating the cost matrix. If not provided, the cost matrix will be calculated automatically based on the latitude and longitude of the locations. A partial cost matrix can be provided to avoid recalculating travel durations and distances between locations.
 * @member {Array.<module:model/TravelCost>} travelCosts
 */
CostMatrixRequest.prototype['travelCosts'] = undefined;

/**
 * @member {module:model/CostSettings} costSettings
 */
CostMatrixRequest.prototype['costSettings'] = undefined;

/**
 * @member {module:model/CoordinateSystem} coordinateSystem
 */
CostMatrixRequest.prototype['coordinateSystem'] = undefined;






export default CostMatrixRequest;

